"use client";
// import { ImProvider } from "@/components/im/im-provider";
import BottomNav from "@/components/platform/BottomNav";
import PageHeader from "@/components/platform/page-header";
import TopicTabs from "@/components/platform/topic-tabs";
import { UnreadCountSync } from "@/components/platform/unread-count-sync";
import { useScrollTopOnNav } from "@/hooks/use-scroll-top-on-nav";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";
import { useRef } from "react";

export default function MainLayout( { children }: Readonly<{ children: React.ReactNode }> ) {
    const pathname = usePathname();
    // 定义主页面列表（需要显示 PageHeader 和 BottomNav 的页面）
    const mainPagesWithHeader = [
        "/", // 首页
        "/live",
        "/search",
        "/main-event-detail",
        "/leaderboard",
        "/event",
    ];

    const BOTTOM_NAV_ROUTE_PATHS = [ "/", "/live", "/portfolio", "/me" ] as const;

    // 定义需要显示 BottomNav 但不显示 PageHeader 的页面
    const mainPagesWithoutHeader = [ "/me", "/im" ];

    // 判断页面类型
    const isMainPageWithHeader = mainPagesWithHeader.some( ( page ) => {
        if ( page === "/" ) {
            return pathname === "/";
        }
        return pathname.startsWith( page );
    } );

    const isBottomNavRoute = BOTTOM_NAV_ROUTE_PATHS.includes( pathname as any );
    const isMainPageWithoutHeader = mainPagesWithoutHeader.some( ( page ) => pathname.startsWith( page ) );
    const isMainPage = isMainPageWithHeader || isMainPageWithoutHeader;

    const container = useRef<HTMLDivElement>( null );
    useScrollTopOnNav( container );

    return (
        <>
            <UnreadCountSync />
            <div className="flex flex-col h-full relative">
                {/* 顶部固定导航 - 只在有 header 的主页面显示 */}
                {isMainPageWithHeader && <PageHeader />}
                <TopicTabs />

                {/* 主内容区域 */}
                <div
                    className={cn( "pull-to-refresh-container overflow-y-auto flex-1", {
                        "px-4": !pathname.startsWith( "/im" ),
                        "bg-surface-base": !isBottomNavRoute,
                    } )}
                    ref={container}
                >
                    {children}
                </div>

                {/* 底部导航 - 只在主页面显示 */}
                {isMainPage && <BottomNav />}
            </div>
        </>
    );
}
